import { Box, Typography } from "@mui/material";
import React from "react";
import CertificateOrLicense, {
  CertificateOrLicenseLoading,
} from "./CertificateOrLicense";
import { Certificate } from "../../../types";
import { colors } from "../../../theme/palette";
import { useTranslation } from "react-i18next";

const EntityCertificates = ({
  certificates,
  isLoading,
}: {
  certificates: Certificate[];
  isLoading?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: colors.White,
        borderRadius: "8px",
        padding: "20px 16px",
      }}
    >
      <Typography
        variant="body16ExtraBold"
        sx={{
          display: "block",
          marginBottom: "32px",
          color: colors.Black100,
        }}
      >
        {t("pages.entity.licenseAndCertificate")}
      </Typography>
      <Box>
        {isLoading &&
          [...Array(3)].map((_, idx) => (
            <CertificateOrLicenseLoading key={idx} />
          ))}
        {!isLoading && certificates.length === 0 && (
          <Typography
            variant="body14Regular"
            sx={{
              color: colors.Black100,
            }}
          >
            {t("pages.entity.noLicenseOrCertificate")}
          </Typography>
        )}
        {!isLoading &&
          certificates.length > 0 &&
          certificates.map((certificate) => (
            <CertificateOrLicense
              key={certificate.title}
              certificate={certificate}
            />
          ))}
      </Box>
    </Box>
  );
};

export default EntityCertificates;
